import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-apollo';

import { Button } from '@sm/wds-react';
import { generateMetricsAttribute } from '@sm/metrics';
import { updateMarketingEmailPreferences } from '../EmailPreferences.graphql';

const UpdatePreferencesButton = ({
  encryptedEmail,
  emailPreferences,
  categoriesChanged,
  origin,
  campaignId,
  flow,
  disabled,
  handleSuccess,
  handleError,
  children,
}) => {
  const [updatePreferences] = useMutation(updateMarketingEmailPreferences, {
    variables: {
      marketingEmailPreferences: emailPreferences,
      encryptedEmail,
      campaignId,
      origin,
    },
    refetchQueries: ['marketingEmailPreferencesQuery'],
    onCompleted: handleSuccess,
    onError: handleError,
  });

  return (
    <Button
      data-testid="UpdatePreferencesButton"
      onClick={updatePreferences}
      disabled={disabled}
      data-sm-metrics={generateMetricsAttribute({
        data: {
          actionFlow: 'marketing_email_preferences',
          actionType: `update_preferences_${flow}.button_click`,
          categoriesChanged,
        },
      })}
    >
      {children}
    </Button>
  );
};

UpdatePreferencesButton.propTypes = {
  encryptedEmail: PropTypes.string.isRequired,
  emailPreferences: PropTypes.shape({
    newsletter: PropTypes.bool,
    surveyBestPractices: PropTypes.bool,
    dataStories: PropTypes.bool,
    customerOpportunities: PropTypes.bool,
    purchaseInquiries: PropTypes.bool,
    productResearch: PropTypes.bool,
  }).isRequired,
  categoriesChanged: PropTypes.shape({
    newsletter: PropTypes.bool,
    surveyBestPractices: PropTypes.bool,
    dataStories: PropTypes.bool,
    customerOpportunities: PropTypes.bool,
    purchaseInquiries: PropTypes.bool,
    productResearch: PropTypes.bool,
  }),
  origin: PropTypes.string,
  campaignId: PropTypes.string,
  flow: PropTypes.string,
  disabled: PropTypes.bool,
  handleSuccess: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

UpdatePreferencesButton.defaultProps = {
  categoriesChanged: {},
  origin: null,
  campaignId: null,
  flow: '',
  disabled: false,
};

export default UpdatePreferencesButton;
